import { Table, TableHead, TableCell, TableRow, TableContainer, Paper } from "@mui/material";
import CustomTableBody from "../../../../../utilis/component/CustomTableBody";
import { BilledDetails } from "../../type";

interface DetailsTableProps {
  data: BilledDetails[];
}

const headers = [
  "Sl no",
  "Bill No",
  "Item Code",
  "Name",
  "Rate",
  "Unit",
  "Amount",
  "Ins Discount",
  "Ins Amount",
  "Pat Share",
  "Billed By",
];

// Define column widths (adjust these values as needed)
const columnWidths = {
  "Bill No": "100px",
  "Sl no": "60px",
  "Item Code": "100px",
  "Name": "150px",
  "Rate": "80px",
  "Unit": "60px",
  "Amount": "100px",
  "Ins Discount": "100px",
  "Ins Amount": "100px",
  "Pat Share": "100px",
  "Billed By": "120px",
};

const DetailsTable = ({ data }: DetailsTableProps) => {
  return (
    <TableContainer
      component={Paper}
      sx={{
        maxWidth: "60vw",
        overflowX: "auto",
        maxHeight: "400px",
        "&::-webkit-scrollbar": { height: "8px", width: "8px" }, // Optional: Customize scrollbar
        "&::-webkit-scrollbar-thumb": { backgroundColor: "#888" },
      }}
    >
      <Table sx={{ tableLayout: "fixed", width: "100%" }}>
        <TableHead
          sx={(theme) => ({
            backgroundColor: theme.palette.primary.main,
            position: "sticky",
            top: 0,
            zIndex: 1,
          })}
        >
          <TableRow>
            {headers.map((item) => (
              <TableCell
                sx={(theme) => ({
                  color: theme.palette.background.paper,
                  width: columnWidths[item as keyof typeof columnWidths], // Set explicit width
                  minWidth: columnWidths[item as keyof typeof columnWidths],
                  padding: "8px",
                  boxSizing: "border-box",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                })}
                key={item}
              >
                {item}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <CustomTableBody
          alert={"No Billed Item"}
          dataLoading={false}
          isData={data.length > 0}
          totalSpan={{ col: 11, row: 3 }} // Adjusted col to match headers count
        >
          {data.map((row, index) => (
            <TableRow key={row.billNo}>
                 <TableCell sx={{ width: columnWidths["Sl no"], padding: "8px", boxSizing: "border-box" }}>
                {index + 1}
              </TableCell>
              <TableCell sx={{ width: columnWidths["Bill No"], padding: "8px", boxSizing: "border-box" }}>
                {row.billNo}
              </TableCell>
           
              <TableCell sx={{ width: columnWidths["Item Code"], padding: "8px", boxSizing: "border-box" }}>
                {row.itemCode}
              </TableCell>
              <TableCell sx={{ width: columnWidths["Name"], padding: "8px", boxSizing: "border-box" }}>
                {row.itemName}
              </TableCell>
              <TableCell sx={{ width: columnWidths["Rate"], padding: "8px", boxSizing: "border-box" }}>
                {row.rate}
              </TableCell>
              <TableCell sx={{ width: columnWidths["Unit"], padding: "8px", boxSizing: "border-box" }}>
                {row.unit}
              </TableCell>
              <TableCell sx={{ width: columnWidths["Amount"], padding: "8px", boxSizing: "border-box" }}>
                {row.amount}
              </TableCell>
              <TableCell sx={{ width: columnWidths["Ins Discount"], padding: "8px", boxSizing: "border-box" }}>
                {row.insDiscount}
              </TableCell>
              <TableCell sx={{ width: columnWidths["Ins Amount"], padding: "8px", boxSizing: "border-box" }}>
                {row.insAmount}
              </TableCell>
              <TableCell sx={{ width: columnWidths["Pat Share"], padding: "8px", boxSizing: "border-box" }}>
                {row.patShare}
              </TableCell>
              <TableCell sx={{ width: columnWidths["Billed By"], padding: "8px", boxSizing: "border-box" }}>
                {row.empName}
              </TableCell>
            </TableRow>
          ))}
        </CustomTableBody>
      </Table>
    </TableContainer>
  );
};

export default DetailsTable;
